/* ============================================================
   Morganics Bundle PDP — buy-box behaviour
   Wires the size cards to the product form: updates the selected
   variant id, price display, compare-at, per-unit text and the
   Add-to-Cart total/availability.
   ============================================================ */
(function () {
  'use strict';

  function initBuyBox(root) {
    var idInput = root.querySelector('[data-mgx-variant-id]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.size-card'));
    var priceAmt = root.querySelector('[data-mgx-price]');
    var priceOld = root.querySelector('[data-mgx-old]');
    var priceEach = root.querySelector('[data-mgx-each]');
    var atcTotal = root.querySelector('[data-mgx-atc-total]');
    var atcBtn = root.querySelector('[data-mgx-atc]');

    function select(card) {
      cards.forEach(function (c) { c.classList.toggle('active', c === card); });

      var vid = card.getAttribute('data-variant-id');
      var available = card.getAttribute('data-available') === 'true';
      var price = card.getAttribute('data-price') || '';
      var compare = card.getAttribute('data-compare') || '';
      var each = card.getAttribute('data-each') || '';

      if (idInput) idInput.value = vid;
      if (priceAmt) priceAmt.innerHTML = price;
      if (priceOld) {
        priceOld.innerHTML = compare;
        priceOld.style.display = compare ? '' : 'none';
      }
      if (priceEach) priceEach.textContent = each || 'per kit';
      if (atcTotal) atcTotal.textContent = available ? '— ' + (card.getAttribute('data-price-plain') || '') : '';

      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.querySelector('.mgx-atc-label').textContent =
          available ? (atcBtn.getAttribute('data-add-label') || 'Add to Cart')
                    : (atcBtn.getAttribute('data-sold-label') || 'Sold out');
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        select(card);
      });
    });

    /* select initial: the pre-marked active card, else first available, else first */
    var initial = root.querySelector('.size-card.active') ||
      cards.filter(function (c) { return c.getAttribute('data-available') === 'true'; })[0] ||
      cards[0];
    if (initial) select(initial);
  }

  function boot() {
    document.querySelectorAll('[data-mgx-buybox]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
